import { useState } from 'react'
import TaskList from './components/TaskList'
import TaskDetail from './components/TaskDetail'
import NewTaskForm from './components/NewTaskForm'
import ToastContainer from './components/ToastContainer'
import { useTaskStore } from './store/taskStore'
import { Plus } from 'lucide-react'

function App() {
  const [showNewTaskForm, setShowNewTaskForm] = useState(false);
  const { selectedTask } = useTaskStore();

  return (
    <div className="min-h-screen bg-soft-gray">
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        <header className="mb-12">
          <div className="flex items-center justify-between">
            <div className="text-center flex-1">
              <h1 className="text-4xl font-bold text-gray-900 mb-2">
                Visual TODO
              </h1>
              <p className="text-soft-muted">
                Modern görev yönetimi, görsellerle zenginleştirilmiş
              </p>
            </div>
            <button
              onClick={() => setShowNewTaskForm(true)}
              className="flex items-center gap-2 px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors shadow-soft"
            >
              <Plus className="w-5 h-5" />
              Yeni Görev
            </button>
          </div>
        </header>

        <main>
          <TaskList />
        </main>
      </div>

      {/* Modals */}
      {showNewTaskForm && (
        <NewTaskForm onClose={() => setShowNewTaskForm(false)} />
      )}
      
      {selectedTask && <TaskDetail />}

      {/* Toast notifications */}
      <ToastContainer />
    </div>
  )
}

export default App
